import * as UiUtil from "@/util/UiUtil";

export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
  case "ep.maot.co.kr":
    return "작업장명";
  case "nhsafe.maot.co.kr":
    return "현장명";
  default:
    return "사업장명";
  }
};


/**
 * 레벤슈타인 거리(Levenshtein Distance)를 계산하는 함수입니다.
 * 이 함수는 두 문자열 간의 '편집 거리'를 측정합니다.
 * 편집 거리란 한 문자열을 다른 문자열로 변환하기 위해 필요한 최소한의 편집 연산(삽입, 삭제, 대체)의 수를 의미합니다.
 *
 * @param {string} a - 첫 번째 문자열
 * @param {string} b - 두 번째 문자열
 * @returns {number} 두 문자열 간의 레벤슈타인 거리
 */
export function levenshteinDistance(a, b) {
  const matrix = [];

  // 첫 번째 행을 초기화합니다.
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  // 첫 번째 열을 초기화합니다.
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // 행렬을 채웁니다.
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      // 문자가 같으면 대각선 위의 값(편집 거리가 증가하지 않음)을 가져옵니다.
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        // 문자가 다르면 삽입, 삭제, 대체 중에서 편집 거리가 가장 작은 연산을 선택합니다.
        matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
      }
    }
  }

  // 마지막으로, 두 문자열 간의 레벤슈타인 거리를 반환합니다.
  return matrix[b.length][a.length];
}

/**
 * 주어진 배열에서 쿼리 문자열과 가장 유사한 요소를 찾는 함수입니다.
 * 이 함수는 레벤슈타인 거리(Levenshtein Distance)를 사용하여 쿼리 문자열과 각 배열 요소 간의 '편집 거리'를 계산하고,
 * 가장 작은 편집 거리를 가진 요소를 반환합니다.
 *
 * @param {Array} arr - 검색 대상이 되는 문자열 배열
 * @param {string} query - 가장 유사한 요소를 찾고자 하는 쿼리 문자열
 * @returns {string} 쿼리 문자열과 가장 유사한 배열 요소
 */
export function findMostSimilar(arr, query) {
  return arr.reduce((a, b) => {
    return levenshteinDistance(query, a) < levenshteinDistance(query, b) ? a : b;
  });
}


export const convertToQueryString = (jsonData) => {
  const result = {};

  const processCondition = (condition, prefix = 'conditions') => {
    if (!condition) return;

    // boolean 값이 있는 경우 처리
    if (condition.boolean) {
      result[`${prefix}[boolean]`] = condition.boolean;
    }

    // 기본 필드(key, operator, value) 처리
    if (condition.key && condition.operator && condition.value) {
      result[`${prefix}[key]`] = condition.key;
      result[`${prefix}[operator]`] = condition.operator;
      result[`${prefix}[value]`] = condition.value;
    }

    // conditions 배열이 있는 경우 재귀적으로 처리
    if (Array.isArray(condition.conditions)) {
      condition.conditions.forEach((subCondition, subIndex) => {
        const subPrefix = `${prefix}[conditions][${subIndex}]`;
        processCondition(subCondition, subPrefix);
      });
    }
  };

  // 최상위 조건들 처리
  jsonData.forEach((condition, index) => {
    processCondition(condition, `conditions[${index}]`);
  });

  // 쿼리 스트링 생성
  const searchParams = new URLSearchParams();
  Object.entries(result).forEach(([key, value]) => {
    if (value != null && value !== '') {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};

let _loadDefragmentation_list = [];
const _loadDefragmentation = async ($store, apiType, options, useLoading) => {
  const response = await $store.dispatch(apiType, options);
  const list = [];
  list.push(...response.data);
  _loadDefragmentation_list.push(...response.data);
  if (useLoading) {
    UiUtil.loading(true, _loadDefragmentation_list.length, response.total);
  }
  if (response.current_page !== response.last_page) {
    options.page = response.current_page + 1;
    const _list = await _loadDefragmentation($store, apiType, options, useLoading);
    list.push(..._list);
    _loadDefragmentation_list.push(..._list);
  }
  return list
};

/**
 * 모든 페이지의 데이터를 불러온다.
 * @param $store
 * @param apiType
 * @param options
 * @returns {Promise<*[]>}
 */
export async function loadDefragmentation($store, apiType, options, useLoading) {
  _loadDefragmentation_list = [];
  if (useLoading) {
    UiUtil.loading(true);
  }
  const list = await _loadDefragmentation($store, apiType, options, useLoading)
  if (useLoading) {
    UiUtil.loading(false);
  }
  return list;
}

export function comma(str) {
  return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
